import React, { Fragment } from "react";
import { Typography, Stack, Box } from "@mui/material";
import { CustomFieldDatePicker } from "../../../components/fields/CustomFieldDatePicker/CustomFieldDatePicker";
import { CustomSelectField } from "./customSelect";

export default function Demographics() {
  return (
    <Fragment key="demoraphics">
      <Typography
        variant="h4"
        sx={{
          color: "var(--Base-1000, #000)",
          fontFamily: "CircularStdBlack",
          fontSize: "24px",
          fontStyle: "normal",
          fontWeight: 900,
          lineHeight: "132%",
        }}
      >
        Demographics
      </Typography>
      <hr style={{ color: "var(--border)", marginTop: "16px" }} />
      <Stack width={1}  mt={2}>
        <Stack direction="row" width={1} spacing={2} mb={3}>
          <CustomSelectField
            name="gender"
            options={["Female", "Male", "Non-Binary", "Other", "Prefer not to say"]}
          />
          <CustomSelectField
            name="isParent"
            label="Are you a Parent?"
            options={["Yes", "No"]}
          />
        </Stack>
        <Stack direction="row" width={1} spacing={2} mb={3}>
          <CustomSelectField
            name="ethnicity"
            options={[
              "American Indian or Alaska Native",
              "Hispanic/Latino",
              "East Asian",
              "South Asian",
              "Black or African American",
              "Native Hawaiian or Other Pacific Islander",
              "White",
              "Two or More Races",
              "No Response",
            ]}
          />
          <Box width={1}>
            <CustomFieldDatePicker
              name="dateOfBirth"
              label="Date of Birth"
              placeholder="DoB"
              fullWidth
              required
            />
          </Box>
        </Stack>
      </Stack>
    </Fragment>
  );
}
